import { atom } from 'jotai'

/**
 * Atom representing the filters applied to the issues.
 */
export const calendarFiltersAtom = atom({
    marketplaces: {
        value: [] as string[],
    },
    financialAdvisors: { value: [] as string[] },
    listed: { value: ['only-listed'] },
    completed: { value: ['not-completed'] },
    issueTypes: { value: ['Rights issue', 'IPO', 'Warrants'] },
    onlyInWatchLists: { value: false },
})
